<template>
  <div>
    <el-form label="状态1" :value="value" class="ms-content">
      <el-form-item prop="userName">
        <el-switch :loading="loading" v-model="value" @change="handelValueChange"></el-switch>
        <span>{{ value ? '开' : '关'}}</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Api from '../api/api.js';
export default {
  data: function() {
    return {
      loading: false,
      value: false
    };
  },
  methods: {
    handelValueChange(value) {
      // console.log('value: ', value);
      this.loading = true;
      const api = value ? Api.tenant.enable : Api.tenant.disable;
      api(2).then(res => {
        if (res.success) {
          this.value = value;
        } else {
          throw new Error(res.msg);
        }
      }).catch(err => {
        this.$message.error(err.message || err);
      }).finally(() => {
        this.loading = false;
      });
    },
    loadState() {
      this.loading = true;
      Api.tenant.getState(2).then(res => {
        if (res.success) {
          this.value = !res.data;
        } else {
          throw new Error(res.msg);
        }
      }).catch(err => {
        this.$message.error(err.message || err);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.loadState();
  }
};
</script>

<style scoped>
.login-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  width: 350px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tenant.vue